// Marquee Swiper
// document.addEventListener('DOMContentLoaded', function () {
  // Get the swiper wrapper
    const marqueeSliders = document.querySelectorAll('.marquee-slider');

  marqueeSliders.forEach(function (slider) {

    const wrapper = slider.querySelector('.swiper-wrapper');

    if (!wrapper) return;

    // Prevent duplicate initialization
    if (slider.classList.contains('swiper-initialized')) {
      return;
    }

    // Get original slides
    const originalSlides = Array.from(wrapper.children);

    // Clone slides for smooth continuous marquee
    originalSlides.forEach(function (slide) {
      const clone = slide.cloneNode(true);

      // Remove Shopify editor attributes from clones
      clone.removeAttribute('data-shopify-editor-block');

      wrapper.appendChild(clone);
    });

    // Initialize THIS slider
    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 60,
      loop: true,
      speed: 3000,

      autoplay: {
        delay: 1,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
      },

      breakpoints: {
        320: {
          spaceBetween: 30
        },
        480: {
          spaceBetween: 50
        },
        750: {
          spaceBetween: 60
        }
      }
    });

  });
// });

// Popup Form Testimonial Swiper
const popupTestimonialSwiper = document.querySelector('.popupTestimonialSwiper');
if(popupTestimonialSwiper) {
  new Swiper('.popupTestimonialSwiper', {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 800,
    navigation: {
      nextEl: '.swiper-popup-button-next',
      prevEl: '.swiper-popup-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    grabCursor: true
  });
}

// Featured Blog
const featureBlogSlider = document.querySelector('.featureBlogSlider');
if (featureBlogSlider) {
  new Swiper(featureBlogSlider, {
      loop: featureBlogSlider.querySelectorAll('.swiper-slide').length > 1, // only loop if >1 slide
      spaceBetween: 10,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: { slidesPerView: 1.2, centeredSlides: true },
        641: { slidesPerView: 1.5, centeredSlides: true },
        1024: { slidesPerView: 3, centeredSlides: false }
      }
  });
}

// Client Testimonials
var swiper = new Swiper(".client-testimonials", {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  loop: true,
  autoHeight: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});

// document.addEventListener("DOMContentLoaded", function () {
  /* ========================
     Dynamically calculate bar height
     ======================== */
  const bars = document.querySelectorAll('.progress-item');
  let maxVotes = 0;

  // 1. Find the max votes
  bars.forEach(bar => {
    const votes = parseInt(bar.dataset.votes);
    if (votes > maxVotes) maxVotes = votes;
  });

  // Function to animate bar height
  function animateBars(progressBar) {
    const activeBars = progressBar.querySelectorAll('.progress-item');
    activeBars.forEach(bar => {
      const votes = parseInt(bar.dataset.votes);
      const fill = bar.querySelector('.progress-option');
      const targetHeight = (votes / maxVotes) * 100; // Percentage height
      let currentHeight = 0;

      const animation = setInterval(() => {
        if (currentHeight >= targetHeight) {
          clearInterval(animation); // Stop when target reached
        } else {
          currentHeight += 1; // Increase by 1%
          fill.style.height = currentHeight + "%";
        }
      }, 10); // Animation speed
    });
  }

  /* ========================
     Quick Poll - Disable Box
     ======================== */
  const titles = document.querySelectorAll(".title h3");
  const box = document.querySelector(".default-image-wrapper");

  titles.forEach((title) => {
    title.addEventListener("click", function () {
      box.classList.add("disable"); // Add class when any title h3 is clicked
    });
  });

  /* ========================
     Tab ProgressBar Animation
     ======================== */
  const headings = document.querySelectorAll('.title h3');

  headings.forEach(h3 => {
    h3.addEventListener('click', function () {
      // 1. Remove 'active' class from all h3 elements
      document.querySelectorAll('.title h3').forEach(title => {
        title.classList.remove('active');
      });

      // 2. Remove 'active' class from all progress bars
      document.querySelectorAll('.progressBar').forEach(bar => {
        bar.classList.remove('active');
      });

      // 3. Add 'active' to the clicked h3
      this.classList.add('active');

      // 4. Add 'active' to the clicked item's progress bar
      const currentProgressBar = this.closest('.item').querySelector('.progressBar');
      currentProgressBar.classList.add('active');

      // 5. Trigger animation for only the active progressBar
      animateBars(currentProgressBar);

      // 6. Add 'active' to the clicked `.polling-votes .block`
      const currentTabBar = this.closest('.polling-votes .block');
      if (currentTabBar) {
        currentTabBar.classList.add('active');
      }


    });
  });
// });

// Success Story Slider
var swiper1 = new Swiper(".stories-slider", {
  loop: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  autoplay: {
    delay: 5000,
  },  
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  } 
});

// Trusted by Clients
var swiper = new Swiper(".upwork-slider", {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  loop: true,
  autoHeight: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: false,
    dynamicMainBullets: 3,
  } 
});

// Home Product Slider
var swiperfeatureProductSlider = new Swiper(".featureProductSlider", {
     slidesPerView: "auto",
     spaceBetween: 30, 
     loop: true,
     autoplay: {
         delay: 2000,
         disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
          centeredSlides: true,
        },
        768: {
          spaceBetween: 30,
        },
      },
    
});

// Who we build
var swiper1 = new Swiper(".who-we-build-slider", {
  loop: true,
  spaceBetween: 20,
  slidesPerView: 'auto',
  centeredSlides: true,
  autoplay: {
    delay: 2000,
  },  
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: false,
    dynamicMainBullets: 3,
  } 
});


// Counter Slider on mobile
let swiperInstance = null;
function initSwiperForMobile() {
  if (window.innerWidth < 768 && !swiperInstance) {
    swiperInstance = new Swiper(".counter-slider", {
      slidesPerView: 1.3,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 4000,
      },
    });
  } else if (window.innerWidth >= 768 && swiperInstance) {
    swiperInstance.destroy(true, true); // Remove swiper on desktop
    swiperInstance = null;
  }
}

// Run on page load
initSwiperForMobile();

// Run on resize
window.addEventListener("resize", initSwiperForMobile);


// Revenue Leaks Slider on mobile
let swiperInstanceRevenue = null;
function initSwiperRevenueForMobile() {
  if (window.innerWidth < 768 && !swiperInstanceRevenue) {
    swiperInstanceRevenue = new Swiper(".revenue-list", {
      slidesPerView: 'auto',
      spaceBetween: 15,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 4000,
      },
    });
  } else if (window.innerWidth >= 768 && swiperInstanceRevenue) {
    swiperInstanceRevenue.destroy(true, true); // Remove swiper on desktop
    swiperInstanceRevenue = null;
  }
}

// ✅ Correct function call
initSwiperRevenueForMobile();

// Run on resize
window.addEventListener("resize", initSwiperRevenueForMobile);


// Upwork Profiles Slider on mobile
let swiperInstanceProfiles = null;
function initSwiperProfilesForMobile() {
  if (window.innerWidth < 768 && !swiperInstanceProfiles) {
    swiperInstanceProfiles = new Swiper(".profileslider", {
      slidesPerView: 1.1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 4000,
      },
    });
  } else if (window.innerWidth >= 768 && swiperInstanceProfiles) {
    swiperInstanceProfiles.destroy(true, true); // Remove swiper on desktop
    swiperInstanceProfiles = null;
  }
}

// Run on page load
initSwiperProfilesForMobile();

// Run on resize
window.addEventListener("resize", initSwiperProfilesForMobile);


// Quick Funnel Design Slider on mobile
let swiperInstanceFunnel = null;
function initSwiperFunnelForMobile() {
  if (window.innerWidth < 768 && !swiperInstanceFunnel) {
    swiperInstanceFunnel = new Swiper(".design-gutter", {
      slidesPerView: 'auto',
      spaceBetween: 15,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 4000,
      },
    });
  } else if (window.innerWidth >= 768 && swiperInstanceFunnel) {
    swiperInstanceFunnel.destroy(true, true); // Remove swiper on desktop
    swiperInstanceFunnel = null;
  }
}

// ✅ Correct function call
initSwiperFunnelForMobile();

// Run on resize
window.addEventListener("resize", initSwiperFunnelForMobile);

// Platforms Slider on mobile
let swiperInstancePlatform = null;
function initSwiperPlatformForMobile() {
  if (window.innerWidth < 768 && !swiperInstancePlatform) {
    swiperInstancePlatform = new Swiper(".platformSlider", {
      slidesPerView: 'auto',
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 1,
        disableOnInteraction: false
      },
    });
  } else if (window.innerWidth >= 768 && swiperInstancePlatform) {
    swiperInstancePlatform.destroy(true, true); // Remove swiper on desktop
    swiperInstancePlatform = null;
  }
}

// ✅ Correct function call
initSwiperPlatformForMobile();

// Run on resize
window.addEventListener("resize", initSwiperPlatformForMobile);


// Integration Tab
$(document).ready(function() {
// Desktop tab click
$('.tools_tab_link').click(function () {
  var tab_id2 = $(this).find('span').data('tab');
  $(this).siblings('li').removeClass('active');
  $('.tools_tab_content').removeClass('active');
  $(this).addClass('active');
  $("#" + tab_id2).addClass('active');
});

// Mobile accordion
if ($(window).width() <= 767) {
  var $tab2 = $(".tools-accordion-body");
  var $tabContent2 = $(".tools_tab_content");
// Open the first (or active) accordion by default on mobile
var $defaultOpen = $(".tools_tab_content.active .tools-accordion-body");
if ($defaultOpen.length === 0) {
  $(".tools_tab_content").removeClass("active");
  $defaultOpen = $(".tools_tab_content").first().addClass("active").find(".tools-accordion-body");
}
  $tab2.hide();
  $defaultOpen.show();

    $(".tools-tab-accordion").click(function () {
        var $parentContent = $(this).parent(".tools_tab_content");

        $parentContent.toggleClass('active').siblings($tabContent2).removeClass('active');

        if ($tab2.is(':visible')) {
            $tab2.slideUp(300);
        }

        if ($(this).next($tab2).is(':visible')) {
            $(this).next($tab2).slideUp(300);
        } else {
            $(this).next($tab2).slideDown(300);
        }
    });
  }
});

// Success Stories Slider
var swiper = new Swiper(".top-stories", {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  loop: true,
  //autoHeight: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});

// Success Story page slider
const swiperContainer = document.querySelector('.whatwedid-slider .swiper-wrapper');

if (swiperContainer) {
  const slideCount = swiperContainer.children.length;

  // Detect mobile or desktop
  const isMobile = window.innerWidth < 768;

  // Condition:
  // Mobile → slider if > 1 slide
  // Desktop → slider if > 2 slides
  if ((isMobile && slideCount > 1) || (!isMobile && slideCount > 2)) {
    const swiper = new Swiper('.whatwedid-slider', {
      slidesPerView: isMobile ? 1 : 2,
      spaceBetween: 0,
      loop: slideCount > 1, // loop only if more than one slide
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
      },
    });
  }
}


// Related Case Studies Slider on Mobile
let swiperInstanceStudies = null;
function initSwiperStudiesForMobile() {
  if (window.innerWidth < 1024 && !swiperInstanceStudies) {
    swiperInstanceStudies = new Swiper(".related-case-studies-slider", {
      slidesPerView: 1,
      spaceBetween: 20,
      //centeredSlides: true,
      loop: true,
      speed: 3000,
      // autoplay: {
      //   delay: 1,
      //   disableOnInteraction: false
      // },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
      },
    });
  } else if (window.innerWidth >= 768 && swiperInstanceStudies) {
    swiperInstanceStudies.destroy(true, true); // Remove swiper on desktop
    swiperInstanceStudies = null;
  }
}

// ✅ Correct function call
initSwiperStudiesForMobile();


$(document).ready(function() {
  // Hide all li items after the 4th one in each list
  $('.services-listing').each(function() {
    $(this).find('li:gt(3)').hide(); // hide from 5th li onwards
  });

  // Toggle hidden list items on click
  $('.toggle-footer-links').on('click', function(e) {
    e.preventDefault();

    const $this = $(this);
    const $list = $this.prev('.services-listing');

    $list.find('li:gt(3)').slideToggle(); // toggle hidden li

    // Toggle text
    if ($this.text().trim() === 'And much more...') {
      $this.text('Show less');
    } else {
      $this.text('And much more...');
    }
  });
});

/* About Page template Up Slider */
var swiperup = new Swiper(".upSlider", {
  loop: true,
  direction: "vertical",
  slidesPerView: "auto",
  speed: 12000,
  mousewheel: true,
  spaceBetween: 30,
  autoplay: {
	  delay: 1,
	  disableOnInteraction: false
  }
});

/* About Page template Down Slider */
// var swiperdown = new Swiper(".downSlider", {
//   loop: true,
//   direction: "vertical",
//   slidesPerView: "auto",
//   speed: 5000,
//   mousewheel: true,
//   spaceBetween: 30,
//   autoplay: {
//     delay: 1,
//     disableOnInteraction: false,
//     reverseDirection: true,
//   },
// });


/* About Page template Down Slider */
var swiperdown = new Swiper(".downSlider", {
  loop: true,
  direction: "vertical",
  slidesPerView: "auto",
  speed: window.innerWidth >= 768 ? 5000 : 12000, // ✅ speed based on device
  mousewheel: true,
  spaceBetween: 30,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
    reverseDirection: window.innerWidth >= 768 // ✅ reverse only on desktop
  },
});

// 🔁 Update autoplay direction & speed on resize
window.addEventListener('resize', () => {
  try{
    const isDesktop = window.innerWidth >= 768;
    swiperdown.params.autoplay.reverseDirection = isDesktop;
    swiperdown.params.speed = isDesktop ? 5000 : 12000;
    swiperdown.update();
    swiperdown.autoplay.stop();
    swiperdown.autoplay.start();
  }
  catch(err){
    // console.log(err)
  }
});


/* Teams Slider */
// const wrapper = document.querySelector('.team-slider .swiper-wrapper');
// const slidesHTML = wrapper.innerHTML;
// wrapper.innerHTML = slidesHTML + slidesHTML; // duplicate slides

// var swiperTeam = new Swiper(".team-slider", {
//   loop: true,
//   slidesPerView: "auto",
//   speed: 8000,
//   spaceBetween: 0,
//   mousewheel: true,
//   allowTouchMove: false,
//   autoplay: {
//     delay: 0,
//     disableOnInteraction: false,
//   },
// });

// Duplicate all .swiper-slide for seamless loop
(function ensureMultipleSlides() {
  const wrapper = document.querySelector('.team-slider .swiper-wrapper');
  if (!wrapper) return;

  const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
  const clonesToAdd = 2; // repeat 2 times for smoothness

  for (let i = 0; i < clonesToAdd; i++) {
    slides.forEach(slide => {
      wrapper.appendChild(slide.cloneNode(true));
    });
  }
})();

// Initialize Swiper marquee
const swiperTeam = new Swiper('.team-slider', {
  slidesPerView: 'auto',
  spaceBetween: 15,
  loop: true,
  speed: 15000, // adjust for marquee speed
  mousewheel: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  on: {
    init(swiper) {
      swiper.wrapperEl.style.transitionTimingFunction = 'linear';
    },
    setTranslate(swiper) {
      swiper.wrapperEl.style.transitionTimingFunction = 'linear';
    }
  }
});

/* Home Banner typing */
const words = ["Design", "Development", "Enabling AI"];
let ii = 0;
let j = 0;
let currentWord = "";
let isDeleting = false;
const speed = 150; // typing speed

function type() {
  const typewriter = document.getElementById("typewriter");

  if (typewriter && ii < words.length) {
    // console.log('typewriter', typewriter, ii);
    
    if (!isDeleting && j <= words[ii].length) {
      currentWord = words[ii].substring(0, j++);
      typewriter.textContent = currentWord;
      setTimeout(type, speed);
    } else if (isDeleting && j >= 0) {
      currentWord = words[ii].substring(0, j--);
      typewriter.textContent = currentWord;
      setTimeout(type, speed / 2);
    } else if (!isDeleting && j > words[ii].length) {
      isDeleting = true;
      setTimeout(type, 1000);
    } else if (isDeleting && j < 0) {
      isDeleting = false;
      ii = (ii + 1) % words.length;
      setTimeout(type, 500);
    }
  }
}
type();

// Home page GHL Slider
var swiperprojectlist = new Swiper(".project-list-slider", {
  loop: true,
  spaceBetween: 30,
  slidesPerView: 'auto',
  autoplay: {
    delay: 5000,
  } 
});

// Home Industry Left Slider
var swiperindustrylist = new Swiper(".left-industrie-slider", {
  slidesPerView: 'auto',
  spaceBetween: 15,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 1,
    disableOnInteraction: false
  }
});

// Home Industry Right Slider
var swiperindustrylistright = new Swiper(".right-industrie-slider", {
  slidesPerView: 'auto',
  spaceBetween: 15,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
    reverseDirection: true
  }
});


// Home Page Funnel Services
const tabNav = document.querySelector('.tab-nav');
if(tabNav) {

  const tabLinks = document.querySelectorAll('.tab-nav .nav-link');
  
  const tabSections = [
    document.getElementById('funnel-services'),
    document.getElementById('platfors-services'),
    document.getElementById('funnel-types')
  ].filter(Boolean);
  
  const stickyOffset = tabNav.offsetTop;
  const stopSection = document.getElementById('stories') || document.getElementById('story10'); // Section after tabs
  
  // --- Sticky Behavior ---
  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const stopPoint = stopSection ? stopSection.offsetTop - 100 : Infinity;
  
    // Handle sticky toggle
    if (scrollTop >= stickyOffset && scrollTop < stopPoint - 400) {
      if (tabNav && !tabNav.classList.contains('is-sticky')) {
        tabNav.classList.add('is-sticky');
      }
    } else {
      tabNav && (tabNav.classList.remove('is-sticky'));
    }
  
    // --- Scroll Spy (Active Tab Highlight) ---
    let currentSection = null;
  
    tabSections.forEach(section => {
      const sectionTop = section.offsetTop - (tabNav.offsetHeight + 60);
      const sectionBottom = sectionTop + section.offsetHeight;
  
      if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
        currentSection = section.id;
      }
    });
  
    if (currentSection) {
      tabLinks.forEach(link => {
        link.classList.toggle('active', link.getAttribute('href') === `#${currentSection}`);
      });
    }
  });
  
  // --- Click-to-Scroll Behavior ---
  tabLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetSection = document.getElementById(targetId);
  
      if (targetSection) {
        const yOffset = tabNav.classList.contains('is-sticky')
          ? tabNav.offsetHeight + 20
          : 20;
  
        const y = targetSection.getBoundingClientRect().top + window.pageYOffset - yOffset;
  
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });
  
  // --- Set default active on load ---
  const defaultLink = document.querySelector('.tab-nav .nav-link[href="#funnel-services"]');
  if (defaultLink) defaultLink.classList.add('active');
}

/*
// Home banner right col
jQuery(function($){
  const $items = $('.technologies li');
  const total = $items.length;
  const itemsToShow = 6;
  const intervalMs = 3000;
  let timer = null;
  let paused = false;

  // Fisher–Yates shuffle
  function shuffleArray(arr){
    for(let i = arr.length - 1; i > 0; i--){
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function pickRandomIndexes(){
    const indices = Array.from({length: total}, (_, i) => i);
    return shuffleArray(indices).slice(0, Math.min(itemsToShow, total));
  }

  function showInitial(){
    $items.addClass('hidden'); // hide using opacity/visibility
    const picks = pickRandomIndexes();
    picks.forEach(idx => $items.eq(idx).removeClass('hidden'));
  }

  function rotateLogos(){
    if (paused) return;

    const $visible = $items.not('.hidden');

    // fade out visible items
    $visible.addClass('hidden');

    setTimeout(function(){
      // fade in new random items
      const picks = pickRandomIndexes();
      picks.forEach((idx, i) => {
        setTimeout(() => {
          $items.eq(idx).removeClass('hidden');
        }, i * 80);
      });
    }, 300);
  }

  // pause on hover
  $('.technologies').on('mouseenter', function(){ paused = true; });
  $('.technologies').on('mouseleave', function(){ paused = false; });

  // init
  showInitial();
  timer = setInterval(rotateLogos, intervalMs);
});
*/

// No Follow
// document.querySelectorAll('a[target="_blank"]').forEach(function(link) {
//   // If rel already exists, append nofollow only if missing
//   if (link.hasAttribute('rel')) {
//       let relValue = link.getAttribute('rel');
//       if (!relValue.includes('nofollow')) {
//           link.setAttribute('rel', relValue + ' nofollow');
//       }
//   } else {
//       link.setAttribute('rel', 'nofollow');
//   }
// });
(function() {

    function addNoFollow() {

        // Skip blog pages
        if (
            window.location.pathname.startsWith('/blogs/')
        ) {
            return;
        }

        const currentHost = location.hostname.replace('www.', '');

        document.querySelectorAll('a[href]').forEach(function(link) {

            const href = link.getAttribute('href');
            if (!href) return;

            // Ignore internal links
            if (
                href.startsWith('/') ||
                href.startsWith('#') ||
                href.startsWith('mailto:') ||
                href.startsWith('tel:') || 
                href.startsWith('javascript:')
            ) {
                return;
            }

            try {
                const url = new URL(href, location.origin);
                const hostname = url.hostname.replace('www.', '');

                // Skip internal links
                if (hostname === currentHost) return;

                // Excluded domains
                if (
                    hostname.includes('ogwebsolutions.com') ||
                    hostname.includes('gohighlevelteam.com')
                ) {
                    return;
                }

                let rel = link.getAttribute('rel') || '';

                if (!rel.includes('nofollow')) {
                    rel += (rel ? ' ' : '') + 'nofollow';
                    link.setAttribute('rel', rel.trim());
                }

            } catch(e) {}
        });
    }

    addNoFollow();

    // Handle dynamically added links
    const observer = new MutationObserver(addNoFollow);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();

// Page scrolls smoothly
$(document).on("click", 'a[href^="#"]', function (e) {
  const targetId = $(this).attr("href");

  if (targetId.length > 1 && $(targetId).length) {
    e.preventDefault();

    const headerOffset = 100; // adjust if needed
    const targetOffset = $(targetId).offset().top - headerOffset;

    $("html, body").animate(
      { scrollTop: targetOffset },
      600
    );

    // remove hash from URL
    history.replaceState(null, "", window.location.pathname);
  }
});

// Product Tab
jQuery(document).ready(function ($) {

  function getStickyOffset() {
      var headerHeight = $('sticky-header').outerHeight() || 0;
      var tabsHeight = $('.tabsList').outerHeight() || 0;
      return headerHeight + tabsHeight;
  }

  var tabLinks = $(".tabsList h2");
  var tabContents = $(".tabsContent");

  tabLinks.on("click", function (e) {
      e.preventDefault();

      var target = $(this).attr("data-tab");

      // Remove active from all tabs
      tabLinks.removeClass("active");

      // Hide all tab contents
      tabContents.removeClass("active");

      // Add active to clicked tab
      $(this).addClass("active");

      // Show selected tab
      var targetContent = $('#' + target);
      targetContent.addClass("active");

      var offset = getStickyOffset();

      $("html, body").animate({
          scrollTop: targetContent.offset().top - offset -30
      }, 500);
  });

  $(document).on('click', '[data-review]', function(e) {
      e.preventDefault();

      var target = $(this).data('review');
      var offset = getStickyOffset();

      $('html, body').animate({
          scrollTop: $(target).offset().top - offset -30
      }, 800);
  });

});